<template>
  <div class="modal-backdrop fade show" bis_skin_checked="1"></div>
  <div
    class="modal fade show"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    bis_skin_checked="1"
    style="display: block; padding-left: 0px"
    aria-modal="true"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      role="document"
      bis_skin_checked="1"
    >
      <div class="modal-content border-0" bis_skin_checked="1">
        <div class="modal-header p-4 pb-0" bis_skin_checked="1">
          <h4 class="modal-title" id="createMemberLabel">
            Add Payment ({{ invoiceSummary.invoiceNo }})
          </h4>
          <button
            type="button"
            class="btn-close"
            id="createMemberBtn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closePopup"
          />
        </div>
        <div class="modal-body p-4" bis_skin_checked="1">
          <form>
            <div class="row" bis_skin_checked="1">
              <div class="col-sm-auto col-md" bis_skin_checked="1">
                <div class="mb-3 row" bis_skin_checked="1">
                  <h5 class="col-sm-auto col-md text-center">
                    <strong>Invoice Total:</strong> ${{ invoiceSummary.total }}
                  </h5>
                  <h5 class="col-sm-auto col-md text-center">
                    <strong>Due:</strong>
                    ${{ invoiceSummary.balance }}
                  </h5>
                </div>

                <div
                  v-if="payment.paymentType === 'cheque' && printCheque"
                  class="mb-3"
                  bis_skin_checked="1"
                >
                  <label for="billerID" class="form-label">Biller</label>
                  <select
                    id="billerID"
                    class="form-select"
                    v-model="selectedBillerID"
                  >
                    <option value="">Select Biller</option>
                    <option
                      v-for="biller in chequeBillers"
                      :key="biller.id"
                      :value="biller.id"
                    >
                      {{
                        biller.company || biller.name || `Biller ${biller.id}`
                      }}
                    </option>
                  </select>
                </div>

                <div class="mb-3" bis_skin_checked="1">
                  <label for="date" class="form-label">Date</label>
                  <DateInput v-model="payment.date" />
                </div>

                <div class="row" bis_skin_checked="1">
                  <div class="col-sm-auto col-md" bis_skin_checked="1">
                    <div class="mb-4" bis_skin_checked="1">
                      <label for="paymentType" class="form-label">
                        Payment Type
                      </label>
                      <select
                        class="form-select"
                        id="paymentType"
                        v-model="payment.paymentType"
                        aria-label="Default select example"
                      >
                        <option value="">Select Payment Type</option>
                        <option value="cash">Cash</option>
                        <option value="cheque">Cheque</option>
                        <option value="credit">Credit</option>
                        <option value="moneyOrder">Money Order</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-auto col-md" bis_skin_checked="1">
                    <div class="mb-4" bis_skin_checked="1">
                      <label for="amount" class="form-label">Amount</label>
                      <input
                        type="number"
                        class="form-control"
                        id="amount"
                        v-model="payment.amountPaid"
                        placeholder="Enter Amount"
                      />
                    </div>
                  </div>
                </div>

                <div class="mb-3" bis_skin_checked="1">
                  <label for="chequeNo" class="form-label">Cheque No</label>
                  <input
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid':
                        payment.paymentType &&
                        payment.paymentType === 'cheque' &&
                        !payment.chequeNo &&
                        !printCheque,
                    }"
                    :disabled="
                      payment.paymentType &&
                      (payment.paymentType !== 'cheque' || printCheque)
                    "
                    id="chequeNo"
                    v-model="payment.chequeNo"
                    placeholder="Enter Cheque No"
                  />
                  <input
                    class="form-control mt-2"
                    :class="{
                      'is-invalid':
                        payment.paymentType &&
                        payment.paymentType === 'cheque' &&
                        !payment.chequeNo &&
                        !printCheque,
                    }"
                    :disabled="
                      payment.paymentType &&
                      (payment.paymentType !== 'cheque' || printCheque)
                    "
                    type="file"
                    id="chequeImage"
                    name="cheque"
                    accept="image/*"
                    capture="camera"
                  />

                  <div class="invalid-feedback" bis_skin_checked="1">
                    Please enter the Cheque No.
                  </div>
                </div>

                <div class="form-check mb-3" bis_skin_checked="1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="printCheque"
                    v-model="printCheque"
                    :disabled="
                      payment.paymentType && payment.paymentType !== 'cheque'
                    "
                  />
                  <label class="form-check-label" for="printCheque">
                    Print Cheque
                  </label>
                </div>

                <div
                  class="hstack gap-2 justify-content-end"
                  bis_skin_checked="1"
                >
                  <button
                    type="button"
                    class="btn btn-primary"
                    id="addNewMember"
                    @click="submit"
                    :disabled="
                      payment.paymentType &&
                      payment.paymentType === 'cheque' &&
                      ((!payment.chequeNo && !printCheque) ||
                        (printCheque && !selectedBillerID))
                    "
                  >
                    Add Payment
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    data-bs-dismiss="modal"
                    @click="closePopup"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateInput from "@/components/utils/DateInput";
export default {
  name: "AddPaymentModal",
  components: { DateInput },
  data() {
    return {
      payment: {},
      printCheque: true,
      selectedBillerID: "",
    };
  },
  props: {
    invoiceSummary: {
      type: Object,
      required: true,
    },
    closePopup: {
      type: Function,
      required: true,
    },
  },
  computed: {
    chequeBillers() {
      return (this.$store.getters.allBillers || []).filter(
        (biller) =>
          biller.bankName &&
          biller.bankAddress &&
          Number(biller.routingNo) &&
          Number(biller.accountNo) &&
          biller.nextChequeNo !== null &&
          biller.nextChequeNo !== undefined
      );
    },
  },
  methods: {
    async submit() {
      this.payment.invoiceID = this.invoiceSummary.id;
      this.payment.amountPaid = this.payment.amountPaid
        ? this.payment.amountPaid
        : 0;
      if (this.printCheque) {
        this.payment.printCheque = true;
        this.payment.billerID = this.selectedBillerID;
      }
      this.payment.amountDue = (
        this.invoiceSummary.balance - this.payment.amountPaid
      ).toFixed(2);
      const formData = new FormData();
      const fileInput = document.querySelector("#chequeImage");
      if (fileInput) {
        formData.append("chequeImage", fileInput.files[0]);
      } else {
        formData.append("chequeImage", null);
      }
      formData.append("payment", JSON.stringify(this.payment));
      await this.$store.dispatch("addDistributorPayment", formData);
      this.closePopup();
      location.reload();
    },
  },
  async created() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    // this.payment.date = `${month}-${day}-${year}`;
    this.payment.date = `${year}-${month}-${day}`;
    this.payment.amountPaid = this.invoiceSummary.balance;
    this.payment.status = "paid";
    this.payment.paymentType = "";
    await this.$store.dispatch("getBillers", {
      sortingList: [{ id: 1 }],
      resultsPerPage: 1000,
    });
    if (this.chequeBillers.length) {
      this.selectedBillerID = this.chequeBillers[0].id;
    }
  },
};
</script>

<style scoped></style>
